import { createAsyncThunk } from '@reduxjs/toolkit';

export const testAction = createAsyncThunk('header/testAction', () => {
    console.log('test');
});
